import { useEffect, useMemo, useRef, useState } from "react";
import dorpDownImage from '../../../assets/images/dropdown.svg'

const HoldingsStatementSelector = ({
  label = "Statement:",
  emptyText = "No statements available",
  placeholder = "Select statement(s)",
  singularSummarySuffix = "selected",
  pluralSummarySuffix = "selected",
  options = [],
  selectedIds,
  onSelectionChange,
  wrapperClassName = "holdings-statement-filter",
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const containerRef = useRef(null);

  const normalizedSelectedIds = useMemo(() => Array.from(selectedIds || []).map(String), [selectedIds]);
  const selectedIdSet = useMemo(() => new Set(normalizedSelectedIds), [normalizedSelectedIds]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (!containerRef.current?.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const summaryText = useMemo(() => {
    if (normalizedSelectedIds.length === 0) {
      return placeholder;
    }

    if (normalizedSelectedIds.length === 1) {
      return options.find((option) => String(option.id) === normalizedSelectedIds[0])?.text || `1 ${singularSummarySuffix}`;
    }

    return `${normalizedSelectedIds.length} ${pluralSummarySuffix}`;
  }, [normalizedSelectedIds, options, placeholder, pluralSummarySuffix, singularSummarySuffix]);

  const handleToggle = (itemId, isChecked) => {
    const next = new Set(normalizedSelectedIds);

    if (isChecked) {
      next.add(String(itemId));
    } else {
      next.delete(String(itemId));
    }

    onSelectionChange(Array.from(next));
  };

  return (
    <div className={wrapperClassName} ref={containerRef}>
      <label className="control-label custom-fonts holdings-label">{label}</label>

      <div className={`holdings-multiselect ${isOpen ? "open" : ""}`}>
        <button
          type="button"
          className=" custom-fonts holdings-multiselect-trigger"
          onClick={() => setIsOpen((prev) => !prev)}
          aria-expanded={isOpen}
        >
          <span className="holdings-multiselect-summary">{summaryText}</span>
          {/* <span className="holdings-multiselect-caret" aria-hidden="true" /> */}
          <img className="holdings-multiselect-caret" src={dorpDownImage} alt="" />
        </button>

        {isOpen && (
          <div className="holdings-multiselect-menu">
            {options.length === 0 && (
              <div className="holdings-multiselect-empty">{emptyText}</div>
            )}

            {options.map((option) => {
              const isSelected = selectedIdSet.has(String(option.id));
              return (
                <label key={option.id} className="holdings-multiselect-option">
                  <input
                    type="checkbox"
                    checked={isSelected}
                    onChange={(e) => handleToggle(option.id, e.target.checked)}
                  />
                  <span className="holdings-multiselect-option-text">
                    <span className="holdings-multiselect-option-title">{option.text}</span>
                  </span>
                </label>
              );
            })}
          </div>
        )}
      </div>
    </div>
  );
};

export default HoldingsStatementSelector;
